module.exports = __webpack_public_path__ + "img/header-screen.c3d34403.png";